// 📁 ortak/src/context/AuthContext.js
import React, { createContext, useContext, useEffect, useState } from "react";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth, db } from "../firebaseConfig";
import { doc, getDoc } from "firebase/firestore";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser]                   = useState(null);
  const [role, setRole]                   = useState(null);
  const [userPermissions, setUserPermissions] = useState(null);
  const [loading, setLoading]             = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
        try {
          const userRef  = doc(db, "users", currentUser.email);
          const userSnap = await getDoc(userRef);

          if (userSnap.exists()) {
            const data = userSnap.data();

            console.log("📦 Firestore'dan gelen kullanıcı verisi:", data);

            setRole((data.role || "").toLowerCase() || null);

            // Tüm modül izinleri buradan dağıtılıyor
            setUserPermissions({
              yetkiKontrol: data.yetkiKontrol === true || data.YetkiKontrol === true,
              YetkiKontrol: data.YetkiKontrol === true || data.yetkiKontrol === true,
              // Fatura takip (eski yapı — spread olarak kaldı, gerekirse kaldırılabilir)
              ...( data.fatura || {} ),

              // Modül bazlı izinler
              aractakip:        data.aractakip || data["arac-takip"] || {},
              "arac-takip":     data["arac-takip"] || data.aractakip || {},
              kazatakip:        data.kazatakip        || {},
              filotakip:        data.filotakip        || {},
              personeltakip:    data.personeltakip    || {},
              mazottakip:       data.mazottakip       || {},  // alan adı farklıysa güncelle
              "mazot-takip":    data["mazot-takip"]   || {},
              hazirBeton:       data["hazir-beton"]   || {},
              cimentoOperasyonu: data["cimento-operasyonu"] || {},
              "cimento-operasyonu": data["cimento-operasyonu"] || {},
              "isg-yonetimi": data["isg-yonetimi"] || {},
              fatura:           data.fatura           || {},
              kisiyeOzelRapor:  data["kisiye-ozel-rapor"] || {},
              "kontrol-formlari": data["kontrol-formlari"] || {},
            });

          } else {
            console.warn("⚠️ Firestore'da kullanıcı kaydı yok.");
            setRole(null);
            setUserPermissions({});
          }
        } catch (err) {
          console.error("❌ Firestore kullanıcı verisi alınamadı:", err);
          setRole(null);
          setUserPermissions({});
        }
      } else {
        setUser(null);
        setRole(null);
        setUserPermissions(null);
      }

      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const logout = async () => {
    await signOut(auth);
    setUser(null);
    setRole(null);
    setUserPermissions(null);
  };

  return (
    <AuthContext.Provider value={{ user, role, userPermissions, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};
